import React from 'react';
import { Field, ErrorMessage } from 'formik';
import CustomDatePicker, { CMDatePicker } from './datepicker2.styles';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { ReactComponent as CalendarIcon } from '../../icons/calendar3.svg';
import { CMErrorMessage } from '../Input-field/input-field.styles';
import dayjs from 'dayjs';

const Datepicker2 = ({ name, ...props }) => {
  const getMinAgeDate = () => {
    const currentDate = new Date();
    const minAgeDate = new Date(currentDate.getFullYear() - 18, currentDate.getMonth(), currentDate.getDate());
    return dayjs(minAgeDate); 
  };

  const handleChange = (date, form, field) => {
    const formattedDate = date ? dayjs(date).format('MM/DD/YYYY') : null; 
    form.setFieldValue(field.name, formattedDate);
  };

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <CustomDatePicker
        openTo="year"
        views={['year', 'month', 'day']} 
        components={{
          OpenPickerIcon: CalendarIcon
        }}
        className='datepicker'
        onChange={(date) => handleChange(date, props.form, props.field)}
        format="MM/DD/YYYY" 
        maxDate={getMinAgeDate()} 
        {...props}
      />
    </LocalizationProvider>
  );
};

export default Datepicker2;

export const DatepickerErrorMessage = ({ name }) => (
  <ErrorMessage name={name} component={CMErrorMessage} variant='caption' />
);

